"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../../utils/core"));

(function (webf) {
  webf.lang.en = webf.lang.en || {};
  webf.lang.en.datagrid = {
    search: 'Search',
    refresh: 'Refresh',
    allColumns: 'All columns',
    abbrColumn: '#',
    today: 'Today',
    noDate: 'No date'
  };
})(_core["default"]);